import { ChatBotView } from "../chatBot/views/ChatBotView";
import { ChatBotConfigProvider } from "./providers/chatBotConfigContext";
function ChatBot() {
  return <ChatBotView />;
}

export default ChatBot;
